import { Link } from "react-router-dom";
import { imageUrl } from "../../utils/imageUrl";

const HomeBanner = ({ section }) => {
  const settings = section?.settings || {};
  const kicker = settings.kicker || "Jooti Editorial";
  const title = settings.title || section.title || "استایل راحت، مینیمال و زنانه";
  const subtitle = settings.subtitle || "انتخاب‌هایی برای روزهایی که زیبایی و راحتی را با هم می‌خواهی.";
  const buttonText = settings.button_text || "مشاهده کالکشن";
  const buttonLink = settings.button_link || "/category/women-sandals";
  const image = settings.image || "";
  const mobileImage = settings.mobile_image || image;
  const variant = settings.variant || "soft";
  const alignment = settings.alignment || "right";
  const displayMode = settings.display_mode || "split";
  const hasImage = Boolean(image || mobileImage);
  const isFullImage = displayMode === "full_image" && hasImage;

  if (isFullImage) {
    const visual = (
      <picture>
        {mobileImage && <source media="(max-width: 640px)" srcSet={imageUrl(mobileImage)} />}
        <img src={imageUrl(image || mobileImage)} alt={title} loading="lazy" />
      </picture>
    );

    return (
      <section className="home-dynamic-section home-editorial-banner home-editorial-banner-full-image">
        {buttonLink ? (
          <Link to={buttonLink} className="home-editorial-banner-full-link" aria-label={title}>
            {visual}
          </Link>
        ) : (
          <div className="home-editorial-banner-full-link">
            {visual}
          </div>
        )}
      </section>
    );
  }

  return (
    <section className={`home-dynamic-section home-editorial-banner home-editorial-banner-${variant} home-editorial-banner-align-${alignment} ${hasImage ? "has-image" : "is-text-only"}`}>
      <div className="home-editorial-banner-content">
        {kicker && <span>{kicker}</span>}
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}

        {buttonText && buttonLink && (
          <Link to={buttonLink}>
            {buttonText}
          </Link>
        )}
      </div>

      <div className="home-editorial-banner-visual" aria-hidden={!hasImage}>
        {hasImage ? (
          <picture>
            {mobileImage && <source media="(max-width: 640px)" srcSet={imageUrl(mobileImage)} />}
            <img src={imageUrl(image || mobileImage)} alt={title} loading="lazy" />
          </picture>
        ) : (
          <div className="home-editorial-banner-placeholder">
            <strong>Jooti</strong>
            <small>Fashion Edit</small>
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeBanner;
